module.exports = __webpack_public_path__ + "img/paper_upload.0f1a50b0.svg";